import { useState } from "react";
import { toast } from "sonner";

import { useSession } from "@/core/auth/session";
import { ConfirmDialog } from "@/ui/confirm-dialog";

/** Ends every session of the person (all portals, browsers, phones and the app) after confirming. */
export function SignOutEverywhereDialog({ onClose }: { onClose: () => void }) {
  const { me, signOut } = useSession();
  const [busy, setBusy] = useState(false);
  return (
    <ConfirmDialog
      title="Sign out everywhere"
      subject={me?.email ?? "Your account"}
      tone="danger"
      effect="Ends your Brocoly sign-in on every portal, browser and phone, including the Brocoly app. Use it if you lost a device or forgot to sign out on a shared computer."
      confirmLabel="Sign out everywhere"
      busy={busy}
      error={null}
      onConfirm={() => {
        setBusy(true);
        void signOut({ everywhere: true })
          .catch(() =>
            toast.error(
              "Couldn't reach Brocoly to sign out everywhere. You're signed out on this computer; try again from any device.",
            ),
          )
          .finally(() => setBusy(false));
      }}
      onClose={onClose}
    />
  );
}
